import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Date from './Date'

const styles = theme => ({
  root: {
    margin: '0 30px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `2px solid ${theme.borderColor}`
  },
})

class Note extends Component {
  render () {
    const { note, classes } = this.props
    return (
      <div className={classes.root} style={Object.assign({}, styles)}>
        <Date date={note.time} />
        <Typography>
          { note.text }
        </Typography>
      </div>
    )
  }
}

export default withStyles(styles)(Note)



// WEBPACK FOOTER //
// ./src/components/Note.js